import React from 'react';
import './Prescreen.css';
import {xpressApi, GET_QUESTIONNAIRE_DATA} from '../../providers/xpress_api';
import {DotLoader} from 'react-spinners';
import moment from 'moment';
import XpressDialog from '../XpressDialog/XpressDialog';
import {isIOS} from 'react-device-detect';
import Header from "../Common/Header/Header";
import Footer from "../Common/Footer/Footer";
import {VERSION_NUMBER, PATH_ERROR, PATH_QUESTION, XPRESS_STATE_DATE_OF_BIRTH, XPRESS_STATE_FIRST_TIME_DONOR, XPRESS_STATE_ORIGINAL_QUESTION_ID_LIST, XPRESS_STATE_QUESTIONNAIRE_DATA, 
    XPRESS_STATE_QUESTIONNAIRE_NODE_LIST, XPRESS_STATE_RESPONSE_BRANCH_OPTIONS, XPRESS_STATE_RESPONSES, XPRESS_STATE_SEX, XPRESS_STATE_SEX_DESCRIPTION} from "../../App";

export default class Prescreen extends React.Component
{
    constructor(props)
    {
        super(props);

        this.dobInput = React.createRef();
        this.sexInput = React.createRef();
        // this.ftdYesInput = React.createRef();
        // this.ftdNoInput = React.createRef();
        this.continueButton = React.createRef();

		this.showAlertDialog = false;
		this.errors = [];
		this.warnings = [];
		
        //
        // the blood center name and the questionnaire data will be fetched up front, since we need the blood center name for
        // this page.
        //
		this.bloodCenterId = this.props.match.params.bcId;
		this.translationConstants = this.props.xpressState.translationConstants;
        this.bloodCenterName = '';
        this.questionnaireData = null;
        this.language = this.props.xpressState.language;
        this.sex = this.props.xpressState.sex;
        this.dob = this.props.xpressState.dob;
        this.ftd = this.props.xpressState.ftd;
        this.questionnaire = this.props.xpressState.questionnaire;
        this.bloodCenterProperties = this.props.xpressState.bloodCenterProperties;
        this.sexOptions = this.props.xpressState.sexOptions;

        if (!this.bloodCenterProperties) {
            this.props.history.push({
                pathname: PATH_ERROR
            });
        }
        else {
            this.bloodCenterName = this.bloodCenterProperties.bloodCenterName;
        }

        this.state = {
            loading: false,
            showAlertDialog: this.showAlertDialog,
        };
    }

    componentDidMount() {
        this.sexInput.current.value = (this.props.xpressState.sex ? this.props.xpressState.sex : "");
        this.dobInput.current.value = this.props.xpressState.dob;
        /*
        if(this.props.xpressState.ftd !== null) {
            if(this.props.xpressState.ftd) {
                this.ftdYesInput.current.checked = true;
            }
            else {
                this.ftdNoInput.current.checked = true;
            }
        }
        */

        this.checkEnableContinueButton();
    }

    handleSexChange = event =>
    {
        let sex = event.target.value;
        this.sex = sex;

        const sexDescription = event.target.selectedOptions[0].text; // Get the description for the selected sex and store it in the state (HD #10194)

        this.setState({sex: sex});
        this.updateXpressStateValue(XPRESS_STATE_SEX, sex);
        this.updateXpressStateValue(XPRESS_STATE_SEX_DESCRIPTION, sexDescription);

        //
        // move focus automatically to the DOB field
        //
        // Only set focus with non-iOS devices since iOS automatically opens the keyboard on focus, which is not desired
        if(!isIOS) {
            this.dobInput.current.focus();
        }

        this.checkEnableContinueButton();
    };

    handleFtdChange = event => {
        let firstTimeDonor = false;
        if (event.target === this.ftdYesInput.current && event.target.checked) {
            firstTimeDonor = true;
        }

        this.setState({ftd: firstTimeDonor});
        this.updateXpressStateValue(XPRESS_STATE_FIRST_TIME_DONOR, firstTimeDonor);

        this.checkEnableContinueButton();
    }

    handleDOBChange = e =>
    {
        let temp = '';

		// Automatically add forward slashes to the birth date upon entering characters
        if (e.target.value.length < 11) {
            if (e.keyCode !== 193 && e.keyCode !== 111)
            {
                if (e.keyCode !== 8)
                {
                    if (e.target.value.length === 2 || e.target.value.length === 5) {
                        e.target.value = e.target.value + "/";
                    }

                    let slashes = e.target.value.split("/");
                    //fills in first slash for date validation
                    if (e.target.value.length > 2 && slashes.length < 2) {
                        const firstPart = e.target.value.substring(0, 2);
                        const secondPart = e.target.value.substring(2);
                        e.target.value = firstPart + "/" + secondPart;
                    }

                    slashes = e.target.value.split("/");
                    //fills in second slash for date validation
                    if (e.target.value.length > 6 && slashes.length < 3) {
                        const firstPart = e.target.value.substring(0, 5);
                        const secondPart = e.target.value.substring(5);
                        e.target.value = firstPart + "/" + secondPart;
                    }

                    if (e.target.value.length > 10) {
                        e.target.value = e.target.value.substring(0, 10);
                    }
                }
                else
                {
                    temp = e.target.value;
                    if (e.target.value.length === 5)
                    {
                        e.target.value = temp.substring(0, 4);
                    } else if (e.target.value.length === 2)
                    {
                        e.target.value = temp.substring(0, 1);
                    }
                }
            }
            else
            {
                e.target.value = e.target.value.substring(0, e.target.value.length - 1);
            }
        }
        else {
            e.target.value = e.target.value.substring(0, 10);
        }

        let dob = e.target.value;
        this.updateXpressStateValue(XPRESS_STATE_DATE_OF_BIRTH, dob);

        this.checkEnableContinueButton();
    }

    checkEnableContinueButton = () =>
    {
        let sexUndefined = !this.sexInput.current.value;
        let dobUndefined = this.parseBirthDate(this.dobInput.current.value) === null;
        let ftdUndefined = false; // this.ftdYesInput.current.checked === false && this.ftdNoInput.current.checked === false;

        if (sexUndefined || dobUndefined || ftdUndefined) {
            this.continueButton.current.disabled = true;
        }
        else {
            this.continueButton.current.disabled = false;
        }
    }

    handleBackClick = () =>
    {
        window.history.back();
    }

	handleAlertDialogClose = () => {
		this.setState({showAlertDialog: false});
	}

	handleAlertDialogContinue = async () => {
		await this.launchQuestionnaire(this.bloodCenterId);
	}

	isFormValid = () => {
        let sex = this.props.xpressState.sex;
        let dob = this.props.xpressState.dob;
        // let ftd = this.props.xpressState.ftd;

		let formValid = true;
		this.errors = [];
		this.warnings = [];

        if (sex === undefined || sex === "") {
            formValid = false;
        }

		// Perform birth date validations
		let birthDateValid = false;
		// Verify the value is 10 characters in MM/DD/YYYY format
		if (dob && dob.length === 10) {
			const birthDate = this.parseBirthDate(dob);
			if(birthDate) {
				let currentDate = moment(new Date());
				// Verify the birth date is prior to the current date and is no more than 200 years in the past
				if (birthDate.isBefore(currentDate,'days') && currentDate.diff(birthDate, 'year') < 200) {
					// Consider the birth date to be valid at this point
					birthDateValid = true;

					// Verify the donor's age is between 15 and 99 years old, and generate a warning if not (HD #12577/SCRBX-1053)
					const donorAge = currentDate.diff(birthDate, 'year');
					if(donorAge < 15 || donorAge > 99) {
						this.warnings.push(this.translationConstants.prescreenPageAgeWarning.replace('%DONOR_AGE%', donorAge));
					}
				}
			}
		}

		if(!birthDateValid) {
			this.errors.push(this.translationConstants.xpressDialogValidDateText);
		}

		/*
        if (ftd === undefined || ftd === "") {
            formValid = false;
        } 
		*/

		if(this.errors.length > 0 || this.warnings.length > 0) {
			formValid = false;
		}

		return formValid;
	}

    handleContinueClick = async () =>
    {
		const formValid = this.isFormValid();

        if (formValid) {
            await this.launchQuestionnaire(this.bloodCenterId);
        }
		else if(this.errors.length > 0 || this.warnings.length > 0) {
			this.setState({ showAlertDialog: true });
		}
    }

	parseBirthDate(birthDateString) {
		let birthDate = moment(birthDateString, 'MM/DD/YYYY', true);

		if (birthDate.isValid()) {
			return birthDate;
        }
        else{
            return null;
        }
	}

    launchQuestionnaire = async () =>
    {
        this.setState({
            loading: true
        });

        this.questionnaire.sex = this.sex;
        this.questionnaire.translation = this.language;
        this.questionnaire.bloodCenterId = this.bloodCenterId;

        //
        // get the questionnaire data
        //
        let getQuestionnaireDataResponse = await xpressApi.post(GET_QUESTIONNAIRE_DATA, this.questionnaire);
        this.questionnaireData = getQuestionnaireDataResponse.data.questionnaireData;

        this.updateXpressStateValue(XPRESS_STATE_QUESTIONNAIRE_DATA, this.questionnaireData);
        this.updateXpressStateValue(XPRESS_STATE_ORIGINAL_QUESTION_ID_LIST, getQuestionnaireDataResponse.data.originalQuestionIdList);
        this.updateXpressStateValue(XPRESS_STATE_QUESTIONNAIRE_NODE_LIST, getQuestionnaireDataResponse.data.questionnaireNodeList);
        this.updateXpressStateValue(XPRESS_STATE_RESPONSE_BRANCH_OPTIONS, getQuestionnaireDataResponse.data.responseBranchOptions);

        // Initialize the responses array with blank responses for each question
        let responses = this.props.xpressState.responses;
        if(responses.length === 0) {
            this.questionnaireData.questions.forEach((question) => {
                responses.push({questionId: question.questionId, response: undefined});
            });
            this.updateXpressStateValue(XPRESS_STATE_RESPONSES, responses);
        }

        const firstQuestionId = this.questionnaireData.questions[0].questionId;

        this.setState({
            loading: false
        });

        this.props.history.push({
            pathname: PATH_QUESTION.replace(':bcId', this.bloodCenterId).replace(':qId', firstQuestionId)
        });
    };

    updateXpressStateValue = (key, value) => {
        this.props.fnUpdateXpressStateValue(key, value);
    }

    render()
    {
        const translationConstants = this.props.xpressState.translationConstants;
		const errorsExist = this.errors.length > 0;
		const warningsExist = this.warnings.length > 0;

        if (this.state.loading) {
            return (
                <div className="pageWrapper">
                    <div className="contentWrapper">
                        <Header logoPath={this.questionnaire.logoPath} taglinePath={this.questionnaire.taglinePath}/>
                        <DotLoader css={"display: block; margin-top: 23vh; margin-left: auto; margin-right: auto;"} sizeUnit={"px"} size={100} color={'red'} loading={true}/>
                    </div>
                    <Footer text={translationConstants.xpressPoweredBy}/>
                </div>
            );
        }
        else {
			// Create a modal to display errors or warnings if they exist. If errors exist, only an "OK" button will be shown to return to the page. If warnings exist, a
			// "Continue" button will be shown to acknowledge the warnings and continue with the questionnaire, as well as a "Back" button to return to the page (HD #12577/SCRBX-1053)
			const alertDialog = <XpressDialog open={this.state.showAlertDialog}
				title={
						(errorsExist && this.translationConstants.xpressDialogTitleError)
						||
						(warningsExist && this.translationConstants.xpressDialogTitleWarning) 
				} 
				content={
					(errorsExist && 
						<div>
							{this.errors.map((errorMessage, index) => <div key={index}><p>{errorMessage}</p></div>)}
						</div>)
					||
					(warningsExist && 
						<div>
							{this.warnings.map((warningMessage, index) => <div key={index}><p>{warningMessage}</p></div>)}
							<div>{this.translationConstants.prescreenPageWarningContinue}</div>
						</div>)
				} 
				firstButton={
					(errorsExist && "OK")
					||
					(warningsExist && this.translationConstants.prescreenPageContinue)
				}
				handleFirstButtonClick={
					(errorsExist && this.handleAlertDialogClose)
					||
					(warningsExist ? this.handleAlertDialogContinue : null)
				}
				secondButton={
					(errorsExist && null)
					||
					(warningsExist && this.translationConstants.prescreenPageBack)
				}
				handleSecondButtonClick={
					(warningsExist ? this.handleAlertDialogClose : null)
				}/>;

            return (
                <div className="pageWrapper">
                    <div className="contentWrapperWithVersion">
                        <Header logoPath={this.questionnaire.logoPath} taglinePath={this.questionnaire.taglinePath}/>
                        <div className="mx-auto" style={{width: '100%', textAlign:'center'}}>
                            {this.language === "1" && this.questionnaire.welcomePath && <img src={this.questionnaire.welcomePath} className="mt-3 mb-3" style={{maxWidth: "75vw"}} alt="Welcome"/>}
                            {this.language === "2" && this.questionnaire.welcomePathEs && <img src={this.questionnaire.welcomePathEs} className="mt-3 mb-3" style={{maxWidth: "75vw"}} alt="Welcome"/>}

                            <div className="input-group mb-3  mx-auto" style={{marginTop: '1rem', maxWidth:'350px'}}>
                                <span className="input-group-text input-group-prepend" id="basic-addon1" style={{width:'115px'}}>{translationConstants.prescreenPageGender}</span>
                                {/* Only set autoFocus with non-iOS devices since iOS automatically opens the dropdown list on focus, which is not desired */}
                                <select ref={this.sexInput} className="form-control" onChange={this.handleSexChange} style={{width:'200px'}} autoFocus={!isIOS}>
                                    <option key="selectSex" value="">{translationConstants.prescreenPageSelectOption}</option>
                                    {/* Dynamically populate the Sex dropdown list based on the database-driven sex options (HD #10194) */}
                                    {this.sexOptions.map(sexOption => <option key={sexOption.code} value={sexOption.code}>{sexOption.descriptions.find(description => description.translationId === this.language).description}</option>)}
                                </select>
                            </div>

                            <div className="input-group mb-3  mx-auto" style={{marginTop: '40px', maxWidth:'350px'}}>
                                <span className="input-group-text input-group-prepend" id="basic-addon1">{translationConstants.prescreenPageDOB}</span>
                                <input ref={this.dobInput} type="text" placeholder="MM/DD/YYYY" inputMode="numeric" className="form-control" aria-describedby="basic-addon1" maxLength="10" onKeyUp={this.handleDOBChange}/>
                            </div>

                            <div className="mx-auto" style={{width: '100%', justifyContent:'center', alignItems:'center'}}>
                                {/* Remove the First Time Donor question until it's deemed necessary again
                                <div style={{margin: '40px 20px 0px 20px'}}>
                                    <h5>{translationConstants.prescreenPageFTD} {this.bloodCenterName}?</h5>
                                </div>
                                <div className="mx-auto">
                                    <div className="form-check">
                                        <input ref={this.ftdYesInput} type="radio" name="firstTimeDonorRadioGroup" value="Yes" style={{verticalAlign: 'middle'}} onChange={this.handleFtdChange}/>
                                        <label className="form-check-label ftdYesNoLabel" style={{verticalAlign: 'middle'}} >{translationConstants.prescreenPageYes}</label>
                                    </div>
                                    <div className="form-check ftdSpacer">
                                        <input ref={this.ftdNoInput} type="radio" name="firstTimeDonorRadioGroup" value="No" style={{verticalAlign: 'middle'}} onChange={this.handleFtdChange}/>
                                        <label className="form-check-label ftdYesNoLabel" style={{verticalAlign: 'middle'}} >{translationConstants.prescreenPageNo}</label>
                                    </div>
                                </div>
                                */}

                                <button ref={this.continueButton}  className="btn btn-primary" onClick={this.handleContinueClick} style={{width: '110px', marginTop:'20px', marginBottom: '10px'}}>{translationConstants.prescreenPageContinue}</button>
                            </div>
                        </div>
						{alertDialog}
                    </div>
                    <div className="version"><span style={{verticalAlign: 'middle'}}>v{VERSION_NUMBER}</span></div>
                    <Footer text={translationConstants.xpressPoweredBy}/>
                </div>
            );
        }
    }
}